<template>
  <section class="Home">
    <LessonNavigation @sidebarStatus="toggle"></LessonNavigation>
    <Video :flag="isSidebarOpen"></Video>  
    <Description></Description> 
     <click-outside :handler="$event => handleClickOutside($event)"> 
       <transition name="slide-fade">
         <SidebarOverlay
                    v-show="isSidebarOpen"
                    @selectTopic="onSelectTopic"> /*@click.native="toggle"*/
        </SidebarOverlay>
      </transition>
    </click-outside>
    <PageFooter></PageFooter>
  </section>
</template>

<script>
  import { mapMutations } from 'vuex';
  import ClickOutside from 'onclick-outside';
  import PageFooter from './components/PageFooter';
  import SidebarOverlay from './components/SidebarOverlay';
  import LessonNavigation from './components/LessonNavigation';
  import Video from './components/Video';
  import Description from './components/Description';


  export default {
    name: 'Home',

    components: {
      Video,
      SidebarOverlay,
      LessonNavigation,
      PageFooter,
      ClickOutside,
      Description,
    },
  
    data() {
      return {
        isSidebarOpen: false,
        toggleFlag: false,
      };
    },
    created() {
      this.resetQuiz();
      window.fbq('track', 'RDD_HomePageVisit');
    },
  
    methods: {
      ...mapMutations(['resetQuiz']),
      handleClickOutside(e) {
        if (!(
          e.target.className === 'running-menu' ||
            e.target.parentNode.className === 'running-menu'
        )) {
          this.isSidebarOpen = false;
        }
      },
      toggle() {
        this.isSidebarOpen = !this.isSidebarOpen;
      },
      onAttended() {
        this.isSidebarOpen = true;
      },
      onSelectTopic() {
        this.$router.push('/home');
        this.isSidebarOpen = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.8, 0.5, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(-10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/modules/Home/Home.vue